import React from 'react'

function LoadingPage() {
  return (
    <div className="full-display-express">
        <div className="loading-plane">
            
            <div className="loader"></div>
        </div>
    </div>
  )
}

export default LoadingPage